
        <kendo-chart-crosshair-tooltip *ngFor="let key of tooltipKeys" [key]="key">
        </kendo-chart-crosshair-tooltip>
    